import { Link, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client/react";
import { ArrowLeft, Loader2 } from "lucide-react";

import { GET_STUDENT_SKILLS } from "@/graphql/queries/students";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { SkillsManager } from "@/components/skills-manager";

export default function StudentSkillsPage() {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useQuery(GET_STUDENT_SKILLS, {
    variables: { id },
    skip: !id,
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const result = data?.studentSkills;

  if (!result) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Mokinys nerastas</p>
        <Button asChild className="mt-4">
          <Link to="/students">Grįžti į sąrašą</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" asChild>
          <Link to={`/students/${id}`}>
            <ArrowLeft className="h-4 w-4" />
          </Link>
        </Button>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            {result.student.name} - Įgūdžiai
          </h1>
          <p className="text-muted-foreground">
            Detalus mokinio įgūdžių ir pažangos peržiūra
          </p>
        </div>
      </div>

      {(!result.subjects || result.subjects.length === 0) ? (
        <Card>
          <CardContent className="py-12 text-center">
            <p className="text-muted-foreground">Nėra įgūdžių duomenų.</p>
          </CardContent>
        </Card>
      ) : (
        <SkillsManager
          student={result.student}
          subjects={result.subjects}
          learnerSubjects={result.learnerSubjects ?? []}
          unfinishedSessions={result.unfinishedSessions ?? []}
          priorityPlans={result.priorityPlans ?? []}
          liveProficiencies={result.liveProficiencies ?? []}
          studentId={id!}
        />
      )}
    </div>
  );
}
